import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 12l5 5l10 -10","key":"svg-0"}],["path",{"d":"M2 12l5 5m5 -5l5 -5","key":"svg-1"}]]

/**
 * IconChecks
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2hlY2tzIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik03IDEybDUgNWwxMCAtMTAiIC8+CiAgPHBhdGggZD0iTTIgMTJsNSA1bTUgLTVsNSAtNSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/checks
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconChecks = createReactComponent('outline', 'checks', 'Checks', __iconNode);

export default IconChecks;